import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  '& > .MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    gap: 6,

    '& svg': {
      fontSize: 16,
      display: 'block',
    },
  },
  '& .MuiTypography-body1': {
    fontSize: 14,
  },
  '& .MuiTypography-body2': {
    fontStyle: 'italic',
    marginLeft: 6,
    paddingLeft: 12,
    borderLeft: `2px solid ${spaceCadet[300]}`,
  },
});

export default StyledBox;
